import { createContext, useContext } from "react";
import type { PartnerOnboardingProgress, PartnerOnboardingUpdate } from "@dearbill/shared";

export interface PharmacyOnboardingContextValue {
  progress: PartnerOnboardingProgress | null;
  loading: boolean;
  loadError: boolean;
  saving: boolean;
  saveError: boolean;
  reload: () => void;
  save: (update: PartnerOnboardingUpdate) => Promise<boolean>;
}

export const PharmacyOnboardingContext = createContext<PharmacyOnboardingContextValue | null>(null);

/** Non-pharmacy organizations have no introduction state or requests. */
export function usePharmacyOnboarding(): PharmacyOnboardingContextValue | null {
  return useContext(PharmacyOnboardingContext);
}
